import { motion } from "framer-motion";
import bannerImg from "../../../Assets/Images/softConslBanner.png";
import "../Services/SoftConsulting.css";
import { Link } from "react-router-dom";

const SoftConsultingBanner = () => {
  return (
    <div
      className="soft-consult-content"
      style={{
        background: "#0b4f5d",
        color: "white",
      }}
    >
      <div
        className="d-flex flex-column flex-lg-row align-items-center justify-content-center  py-5"
        style={{
          padding: "2rem 0",
          gap: "5rem",
          width: "90%",
          margin: "0 auto",
        }}
      >
        {/* Left Text Section */}
        <div
          className="d-flex flex-column justify-content-start text-center text-md-start align-items-start align-items-md-start"
          style={{
            flex: "1 1 100%",
            maxWidth: "1000px",
          }}
        >
          <h4
            className="sub-heading "
            style={{
              padding: "15px",
              paddingRight: "90px",
              borderRadius: "6px",
              color: "#F7A630",
              backgroundColor: "rgba(250, 250, 250, 0.2)",
            }}
          >
            Web Consulting
          </h4>
          <h2 className="database-heading fw-semibold text-start text-md-start mb-3 px-2">
            Software Consulting
          </h2>
          <p className="small database-text text-start text-md-start  mb-4 px-2">
            Most of the teams reach out for software consulting when something
            feels wrong. A product is increasing but decisions are risky.
            Systems are in place, but progress is slow. We step in at that
            point. At Quad Theory Ltd, there are no big presentations about
            consulting. It is about helping you to see straight and make calm
            decisions.
          </p>
          <p className="small database-text text-start text-md-start  mb-4 px-2">
            We help you
            <ul className="small database-text mb-4">
              <li className="small mb-1">Unravel complicated systems and concepts</li>
              <li className="small mb-1">Validate what ought to be built next</li>
              <li className="small mb-1">Minimize expensive technical errors</li>
              <li className="small mb-1">Match business goals and technical reality</li>
            </ul>
            Our role is simple. Bring clarity before confusion turns expensive.
          </p>
          <Link to="/contact-us">
            <motion.button
              type="button"
              className="data-button px-5 py-3 mx-1 rounded-pill align-self-start mx-0  mx-md-0"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{
                backgroundColor: "#12869E",
                // scale: 1.05,
                boxShadow: "none",
              }}
              transition={{ duration: 0.2 }}
              style={{
                border: "none",
                color: "#fff",
                fontWeight: "500",
                fontSize: "2rem",
              }}
            >
               Talk To A Consultant
            </motion.button>
          </Link>
        </div>

        {/* Right Image Section */}
        <div
          style={{
            flex: "1 1 100%",
            maxWidth: "1000px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 0,
          }}
        >
          <div
            style={{
              width: "100%",
              aspectRatio: "4 / 3",
              maxHeight: "100%",
              overflow: "hidden",
            }}
          >
            <img
              src={bannerImg}
              alt="Software Consulting"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "center",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SoftConsultingBanner;
